(function () {
  var SWIPE_THRESHOLD = 40;
  var DRAG_THRESHOLD = 10;
  var WHEEL_SETTLE_MS = 180;

  function normaliseWheelDelta(event, width) {
    var delta = event.deltaX;
    if (!delta) return 0;
    if (event.deltaMode === 1) delta *= 16;
    else if (event.deltaMode === 2) delta *= width;
    return delta;
  }

  function createWheelScroller(config) {
    var state = { active: false, baseIndex: 0, delta: 0, timer: null, totalPx: 0 };

    function resetTransition() {
      if (typeof config.onTransition === 'function') {
        config.onTransition(true);
      }
    }

    function clearTransition() {
      if (typeof config.onTransition === 'function') {
        config.onTransition(false);
      }
    }

    function applyVisual(totalPx) {
      var width = config.getWidth();
      if (!width) return;
      config.setOffsetPx(totalPx, width);
    }

    function settle() {
      state.active = false;
      state.timer = null;
      resetTransition();

      var width = config.getWidth();
      var maxIndex = config.getMaxIndex();
      var targetIndex = Math.round(state.totalPx / width);
      targetIndex = Math.max(0, Math.min(maxIndex, targetIndex));
      var indexChanged = targetIndex !== state.baseIndex;
      config.setIndex(targetIndex, true);

      if (indexChanged && typeof config.onGesture === 'function') {
        config.onGesture();
      }

      state.delta = 0;
    }

    return function onWheel(event) {
      if (typeof config.isEnabled === 'function' && !config.isEnabled()) return;
      if (Math.abs(event.deltaY) >= Math.abs(event.deltaX)) return;

      var width = config.getWidth();
      var delta = normaliseWheelDelta(event, width);
      if (!delta) return;

      var maxIndex = config.getMaxIndex();
      if (maxIndex < 1) return;

      if (!state.active) {
        state.active = true;
        state.baseIndex = config.getIndex();
        state.delta = 0;
        clearTransition();
      }

      event.preventDefault();

      state.delta += delta;
      state.totalPx = state.baseIndex * width + state.delta;
      state.totalPx = Math.max(0, Math.min(maxIndex * width, state.totalPx));
      state.delta = state.totalPx - state.baseIndex * width;

      applyVisual(state.totalPx);

      if (state.timer) window.clearTimeout(state.timer);
      state.timer = window.setTimeout(settle, WHEEL_SETTLE_MS);
    };
  }

  function bindHorizontalSwipe(surface, onSwipe) {
    if (!surface || surface.dataset.allerasSwipeInit === 'true') return;
    surface.dataset.allerasSwipeInit = 'true';

    var state = { active: false, didDrag: false, startX: 0, startY: 0, pointerId: null };
    var wheelSteps = 0;
    var wheelTimer = null;

    function reset() {
      state.active = false;
      state.didDrag = false;
      state.pointerId = null;
    }

    surface.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('.alleras-col-card__wish, .alleras-col-card__quick, .alleras-col-card__shop, button, input, label')) return;

      state.active = true;
      state.didDrag = false;
      state.startX = event.clientX;
      state.startY = event.clientY;
      state.pointerId = event.pointerId;
    });

    surface.addEventListener('pointermove', function (event) {
      if (!state.active || event.pointerId !== state.pointerId) return;

      var dx = event.clientX - state.startX;
      var dy = event.clientY - state.startY;

      if (!state.didDrag) {
        if (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          reset();
          return;
        }
        state.didDrag = true;
      }
    });

    function finish(event) {
      if (!state.active || event.pointerId !== state.pointerId) return;

      var dx = event.clientX - state.startX;
      var didDrag = state.didDrag;
      reset();

      if (!didDrag || Math.abs(dx) < SWIPE_THRESHOLD) {
        var link = event.target.closest('a[href]');
        if (link && !surface.dataset.allerasSuppressClick && !isModifiedPointerEvent(event)) {
          window.location.assign(link.href);
        }
        return;
      }

      surface.dataset.allerasSuppressClick = 'true';
      window.setTimeout(function () {
        delete surface.dataset.allerasSuppressClick;
      }, 50);
      onSwipe(dx < 0 ? 1 : -1);
    }

    surface.addEventListener('pointerup', finish);
    surface.addEventListener('pointercancel', finish);

    surface.addEventListener(
      'click',
      function (event) {
        if (surface.dataset.allerasSuppressClick && event.target.closest('a')) {
          event.preventDefault();
        }
      },
      true
    );

    surface.addEventListener(
      'wheel',
      function (event) {
        if (Math.abs(event.deltaY) >= Math.abs(event.deltaX)) return;

        var delta = normaliseWheelDelta(event, surface.clientWidth || 1);
        if (!delta) return;

        event.preventDefault();
        wheelSteps += delta;

        if (wheelTimer) window.clearTimeout(wheelTimer);
        wheelTimer = window.setTimeout(function () {
          if (Math.abs(wheelSteps) < SWIPE_THRESHOLD) {
            wheelSteps = 0;
            return;
          }

          onSwipe(wheelSteps < 0 ? 1 : -1);
          wheelSteps = 0;
        }, WHEEL_SETTLE_MS);
      },
      { passive: false }
    );
  }

  function isModifiedPointerEvent(event) {
    return !!(event && (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1 || event.button === 2));
  }

  function shouldIgnoreCardPointerTarget(target) {
    return !!(target && target.closest('.alleras-col-card__wish, .alleras-col-card__quick, .alleras-col-card__shop, button, input, label'));
  }

  function navigateCardLink(link, event) {
    if (!link || !link.href || link.dataset.suppressClick === 'true') return;
    if (isModifiedPointerEvent(event)) return;
    window.location.assign(link.href);
  }

  function initCardLink(card) {
    var link = card.querySelector('.alleras-col-card__image-link, .alleras-pdp__related-media-link');
    if (!link || !link.href || link.dataset.allerasCardLinkInit === 'true') return;

    link.dataset.allerasCardLinkInit = 'true';

    link.addEventListener('click', function (event) {
      if (link.dataset.suppressClick === 'true') {
        event.preventDefault();
        return;
      }

      if (isModifiedPointerEvent(event)) return;

      event.preventDefault();
      navigateCardLink(link, event);
    });
  }

  function initCard(card) {
    if (card.dataset.allerasCardInit === 'true') return;

    var track = card.querySelector('[data-alleras-card-track]');
    if (!track) return;

    var images = track.querySelectorAll('.alleras-col-card__img:not(.alleras-col-card__img--placeholder)');
    if (images.length <= 1) {
      card.dataset.allerasCardInit = 'true';
      return;
    }

    card.dataset.allerasCardInit = 'true';

    var link = card.querySelector('.alleras-col-card__image-link');
    if (!link || !link.href) return;

    var media = card.querySelector('.alleras-col-card__media');
    var surface = track;
    var index = 0;
    var gesture = null;

    function showImage(nextIndex, animate) {
      index = (nextIndex + images.length) % images.length;

      if (animate === false) {
        track.style.transition = 'none';
      } else {
        track.style.transition = '';
      }

      track.style.transform = 'translate3d(-' + index * 100 + '%, 0, 0)';

      if (animate === false) {
        track.offsetHeight;
        track.style.transition = '';
      }
    }

    function setOffsetPx(totalPx, width) {
      var totalPercent = (totalPx / width) * 100;
      track.style.transform = 'translate3d(-' + totalPercent + '%, 0, 0)';
    }

    showImage(0);

    function suppressLinkClick() {
      link.dataset.suppressClick = 'true';
      window.setTimeout(function () {
        delete link.dataset.suppressClick;
      }, 50);
    }

    function cleanupGesture() {
      if (media) media.classList.remove('is-dragging');
      track.style.transition = '';
      document.removeEventListener('pointerup', endGesture);
      document.removeEventListener('pointercancel', endGesture);
      gesture = null;
    }

    function endGesture(event) {
      if (!gesture) return;
      if (event && gesture.pointerId !== null && event.pointerId !== gesture.pointerId) return;
      if (event && shouldIgnoreCardPointerTarget(event.target)) {
        cleanupGesture();
        return;
      }

      var delta = gesture.moved && event ? event.clientX - gesture.startX : 0;
      var swiped = gesture.moved && Math.abs(delta) >= SWIPE_THRESHOLD;

      if (swiped) {
        showImage(index + (delta < 0 ? 1 : -1));
        suppressLinkClick();
        cleanupGesture();
        return;
      }

      if (gesture.moved) {
        showImage(index);
      }

      cleanupGesture();

      // Pointer handlers on the track stop the browser from synthesising a link click.
      navigateCardLink(link, event);
    }

    surface.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (card.classList.contains('is-shop-open')) return;

      cleanupGesture();

      gesture = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        startIndex: index,
        width: (media && media.clientWidth) || surface.clientWidth || 1,
        moved: false
      };

      track.style.transition = 'none';

      document.addEventListener('pointerup', endGesture);
      document.addEventListener('pointercancel', endGesture);
    });

    surface.addEventListener('pointermove', function (event) {
      if (!gesture || event.pointerId !== gesture.pointerId) return;

      var delta = event.clientX - gesture.startX;
      var dy = event.clientY - gesture.startY;

      if (!gesture.moved) {
        if (Math.abs(delta) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;
        if (Math.abs(dy) > Math.abs(delta)) {
          cleanupGesture();
          return;
        }
        gesture.moved = true;
        if (media) media.classList.add('is-dragging');
      }

      var offsetPercent = (delta / gesture.width) * 100;
      track.style.transform =
        'translate3d(calc(-' + gesture.startIndex * 100 + '% + ' + offsetPercent + '%, 0, 0)';
    });

    if (media) {
      var onWheel = createWheelScroller({
        getWidth: function () {
          return media.clientWidth || 1;
        },
        getIndex: function () {
          return index;
        },
        getMaxIndex: function () {
          return images.length - 1;
        },
        isEnabled: function () {
          return !gesture && !card.classList.contains('is-shop-open');
        },
        setOffsetPx: setOffsetPx,
        setIndex: showImage,
        onTransition: function (animate) {
          track.style.transition = animate ? '' : 'none';
          if (!animate) track.offsetHeight;
        },
        onGesture: suppressLinkClick
      });

      media.addEventListener('wheel', onWheel, { passive: false });
    }
  }

  function initCards(root) {
    (root || document).querySelectorAll('[data-alleras-card]').forEach(function (card) {
      initCardLink(card);
      initCard(card);
    });
  }

  window.allerasBindHorizontalSwipe = bindHorizontalSwipe;
  window.allerasInitProductCards = initCards;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCards();
    });
  } else {
    initCards();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCards(event.target);
  });
})();
